import BackgroundVideo from "../../assets/Video Web.mp4";
import LogoGrande from "../../assets/images/Fondo-azul-logo-transparente.png";
import StickyReveal from "../../components/stickyscroll";
import React from "react";
import { useNavigate } from "react-router-dom"; // Agrega useNavigate

//MUI Components
import { Box, Button, Typography, Grid } from "@mui/material";
import CountUp from "react-countup";

//My Components
import { Header } from "../../components/header";
import { IconTab } from "../../components/iconTab";
import ProductosComponent from "../../components/productosComponent";
import MapaObj from "../../components/mapa";
import { TrabajaConNosotros } from "../../components/trabajaConNosotros";
import Contacto from "../../components/contacto";

//Media
import FotoSubestacion from "../../assets/images/interruptoresAlta.jpg";
import IconTool from "../../assets/images/icons/tool.png";
import IconWorker1 from "../../assets/images/icons/worker.png";
import IconWorker2 from "../../assets/images/icons/worker2.png";
import IconCertificate from "../../assets/images/icons/certificate.png";
import { Footer } from "../../components/footer";
import RotatingPlus from "../../components/rotatingPlus";

import { useTranslation } from "react-i18next";

// Ejemplo standalone
function Home() {
  const navigate = useNavigate(); // Hook para navegación
  const { t } = useTranslation();

  return (
    <>
      <Header color={"rgba(255, 255, 255, 1)"} />

      <StickyReveal
        videoSrc={BackgroundVideo}
        imageSrc={LogoGrande}
        maxScale={150}
        scrollHeight={300}
      />

      {/* Nuestra descripcion */}
      <Box
        sx={{
          position: "relative",
          width: "auto",
          height: "87dvh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          backgroundColor: "#6EB1D9",
          overflowX: "hidden",
        }}
      >
        {/* Imagen de fondo fija */}
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: "50%",
            width: "50vw",
            height: "100vh",
            backgroundImage: `url(${FotoSubestacion})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
            overflowX: "hidden",
          }}
        />

        {/* Contenido a la izquierda */}
        <Box
          sx={{
            width: "35%",
            marginLeft: "10%",
            zIndex: 2,
          }}
        >
          <Typography
            sx={{
              color: "#FFF",
              fontFamily: "Montserrat",
              fontSize: { xs: "2rem", sm: "3rem", md: "4rem" },
              fontWeight: "1000",
              lineHeight: "72%", // 👈 antes era 52%
              letterSpacing: "-0.1px",
              marginBottom: "1.97rem",
            }}
          >
            {t("nosotros_titulo")}
          </Typography>

          <Typography
            sx={{
              color: "#FFF",
              fontFamily: "Montserrat",
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" },
              fontWeight: "500",
              lineHeight: "120%",
              marginBottom: "1.4rem",
              marginRigth: "0",
            }}
          >
            {t("nosotros_parrafo")}
          </Typography>

          <Button
            sx={{
              borderRadius: "15px",
              background: "#1B2466",
              padding: "1.25rem 2.25rem",
            }}
            onClick={() => navigate("/quienes-somos/")}
          >
            <Typography
              sx={{
                color: "#FFF",
                fontFamily: "Montserrat",
                fontSize: "15px",
                fontWeight: "500",
                textTransform: "none",
              }}
            >
              {t("ver_mas")}
            </Typography>
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          background: "#1B2466",
          width: "100%",
          minHeight: { xs: "auto", md: "25rem" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 4, md: 0 },
          px: { xs: 2, sm: 4 },
          marginBottom: "5rem"
        }}
      >
        <Grid
          container
          spacing={{ xs: 6, md: 0 }}
          justifyContent="space-around"
          alignItems="center"
        >
          {/* PRESENCIA */}
          <Grid item xs={12} md={4}>
            <Box textAlign="center">
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(16px, 4vw, 29px)",
                  fontWeight: 500,
                  mb: 2,
                }}
              >
                {t("presencia")}
              </Typography>
              <Typography
                component="div"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(36px, 8vw, 96px)",
                  fontWeight: 800,
                  lineHeight: "80%",
                  mb: 2,
                }}
              >
                <span>
                  <CountUp
                    start={0}
                    end={20}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                </span>
                <RotatingPlus />
              </Typography>
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(18px, 4vw, 29px)",
                  fontWeight: 500,
                }}
              >
                {t("paises")}
              </Typography>
            </Box>
          </Grid>

          {/* ELEGIDOS */}
          <Grid item xs={12} md={4}>
            <Box textAlign="center">
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(18px, 4vw, 29px)",
                  fontWeight: 500,
                  mb: 2,
                }}
              >
                {t("elegidos")}
              </Typography>
              <Typography
                component="div"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(36px, 8vw, 96px)",
                  fontWeight: 800,
                  lineHeight: "80%",
                  mb: 2,
                }}
              >
                <span>
                  <CountUp
                    start={0}
                    end={100}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                </span>
                <RotatingPlus />
              </Typography>
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(18px, 4vw, 29px)",
                  fontWeight: 500,
                }}
              >
                {t("clientes")}
              </Typography>
            </Box>
          </Grid>

          {/* LIDERANDO */}
          <Grid item xs={12} md={4}>
            <Box textAlign="center">
              <Typography

                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(18px, 4vw, 29px)",
                  fontWeight: 500,
                  mb: 2,
                }}
              >
                {t("liderando")}
              </Typography>
              <Typography
                component="div"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(36px, 8vw, 96px)",
                  fontWeight: 800,
                  lineHeight: "80%",
                  mb: 2,
                }}
              >
                <span>
                  <CountUp
                    start={0}
                    end={4000}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                  />
                </span>
                <RotatingPlus />
              </Typography>
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "clamp(18px, 4vw, 29px)",
                  fontWeight: 500,
                }}
              >
                {t("soluciones")}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Nuestros Productos */}
      <Box
        sx={{
          marginTop: "-5rem",
        }}
      >
        <ProductosComponent />
      </Box>

      {/* Nuestros Servicios */}
      <Box
        sx={{
          position: "relative",
          background: "#1B2466",
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          py: { xs: 6, md: 10 },
          px: { xs: 2, sm: 4, md: 8 },
        }}
      >
        <Grid container spacing={4} justifyContent="center" alignItems="center">
          {/* Columna Izquierda: Texto */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "32px", sm: "40px", md: "50px" },
                  fontWeight: 800,
                  lineHeight: "110%",
                  mb: 2,
                }}
              >
                {t("nuestros_servicios_titulo")}
              </Typography>

              <Typography
                sx={{
                  color: "#6EB1D9",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "18px", sm: "22px", md: "27px" },
                  fontWeight: 800,
                  lineHeight: "120%",
                  mb: 2,
                }}
              >
                {t("nuestros_servicios_subtitulo")}
              </Typography>

              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "14px", sm: "16px", md: "20px" },
                  fontWeight: 500,
                  lineHeight: "140%",
                  mb: 3,
                }}
              >
                {t("nuestros_servicios_parrafo")}
              </Typography>

              <Button
                sx={{
                  borderRadius: "15px",
                  background: "#6EB1D9",
                  px: { xs: 3, md: 4 },
                  py: { xs: 1.5, md: 2 },
                  "&:hover": { background: "#5CA1C9" },
                }}
                onClick={() => navigate("/servicios/")}
              >
                <Typography
                  sx={{
                    color: "#1B2466",
                    fontFamily: "Montserrat",
                    fontSize: { xs: "15px", md: "17px" },
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  {t("ver_mas")}
                </Typography>
              </Button>
            </Box>
          </Grid>

          {/* Columna Derecha: IconTabs */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                alignItems: { xs: "center", md: "flex-start" },
                mt: { xs: 4, md: 0 },
              }}
            >
              <IconTab iconPath={IconTool} text={t("nuestros_servicios_item1")} />
              <IconTab iconPath={IconWorker1} text={t("nuestros_servicios_item2")} />
              <IconTab
                iconPath={IconWorker2}
                text={t("nuestros_servicios_item3")}
              />
              <IconTab iconPath={IconCertificate} text={t("nuestros_servicios_item4")} />
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Nuestros Representantes */}
      <Box
        sx={{
          position: "relative",
          background: "#FFF",
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Columna en móvil, fila en desktop
          justifyContent: "center",
          alignItems: "center",
          textAlign: { xs: "center", md: "left" }, // Centro texto en móvil
          p: { xs: 2, sm: 3 }, // Padding general responsive
        }}
      >
        {/* Mapa - Orden visual modificado para móvil */}
        <Box
          sx={{
            width: { xs: "100%", md: "37rem" },
            maxWidth: "37rem",
            mt: { xs: 2, md: "3.5rem" },
            mb: { xs: 2, md: "3.5rem" },
            mr: { xs: 0, md: "2rem" }, // Margen derecho solo en desktop
            order: { xs: 2, md: 1 }, // Cambia orden en móvil
          }}
        >
          <MapaObj />
        </Box>

        {/* Texto */}
        <Box
          sx={{
            width: { xs: "100%", md: "37rem" },
            mb: { xs: 3, md: "15rem" },
            ml: { xs: 0, md: "7.5rem" },
            order: { xs: 1, md: 2 }, // Texto primero en móvil
            px: { xs: 2, sm: 0 }, // Padding horizontal en móvil
          }}
        >
          <Typography
            sx={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: {
                xs: "1.8rem",
                sm: "2.2rem",
                md: "3rem",
                lg: "3.9rem",
              }, // Escala progresiva
              fontWeight: 800,
              lineHeight: "110%",
              letterSpacing: "-0.1px",
            }}
          >
            {t("nuestros_representantes_titulo")}
          </Typography>

          <Typography
            sx={{
              color: "#6EB1D9",
              fontFamily: "Montserrat",
              fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" },
              fontWeight: 700,
              lineHeight: "140%",
              mt: { xs: 1.5, md: 2 },
            }}
          >
            {t("nuestros_representantes_subtitulo")}
          </Typography>

          <Typography
            sx={{
              color: "#1B2466",
              fontFamily: "Montserrat",
              fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1.1rem" },
              fontWeight: 500,
              lineHeight: "140%",
              textDecoration: "underline",
              mt: { xs: 1.5, md: 2 },
            }}
          >
            {t("nuestros_representantes_titulo_mapa")}
          </Typography>
        </Box>
      </Box>

      {/* Trabaja Con Nosotros */}
      <Box
        sx={{
          position: "relative",
          background: "#1B2466",
          width: "100%",
          height: "110vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TrabajaConNosotros />
      </Box>

      {/* Contacto */}
      <div
        id="contacto"
        sx={{
          width: "100%",
        }}
      >
        <Contacto />
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Home;
